// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__QMO4z","parent":"tag_parent__9o5Fe","category":"tag_category__dSIug","tagNew":"tag_tagNew__gqgfC"};